import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiX } = FiIcons;

function FitCard({ type, icon, children }) {
  return (
    <div className={`fit-card fit-card-${type}`}>
      <SafeIcon icon={icon} aria-hidden="true" />
      <h3>{type === 'for' ? 'This is for you if…' : 'This is not for you if…'}</h3>
      <p>{children}</p>
    </div>
  );
}

function FitAndScripts() {
  return (
    <>
      <section className="fit section">
        <div className="shell fit-grid">
          <FitCard type="for" icon={FiCheck}>
            You are 0–12 months into management and want to know exactly what
            to do and say next.
          </FitCard>
          <FitCard type="not" icon={FiX}>
            You want frameworks, theory, or research citations. This will
            frustrate you. There are none. It is scripts and sequence, and
            nothing else.
          </FitCard>
        </div>
      </section>

      <section className="scripts navy-section">
        <div className="shell scripts-layout">
          <p className="eyebrow">Why scripts, not theory</p>
          <h2>Vague advice disappears when the conversation gets awkward.</h2>
          <div className="script-rule" />
          <p>
            “Have an honest conversation” is not useful when someone is sitting
            across from you. Specific words are. This toolkit gives you the
            opening sentence, the next question, and the point where you stop
            talking.
          </p>
        </div>
      </section>
    </>
  );
}

export default FitAndScripts;